import requester from '@/lib/axios';
import { MULTIPART_FORM_DATA_HEADERS as headers } from '@/constants';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';
import {
  CourseLine,
  CourseLineCategory,
  CourseLineSubCategory,
} from '@/models/CourseLine';
import {
  convertToFormData,
  bannerImgConverter,
} from '@/utils/convertToFormData';

export type ListCourseLineFilters = BaseFilters & {
  category?: CourseLineCategory;
  subcategory?: CourseLineSubCategory;
};

export const listCourseLines = async (filters: ListCourseLineFilters = {}) => {
  const { data } = await requester().get<JsonApiResponse<CourseLine>>(
    'course-lines/',
    { params: filters },
  );
  return data;
};

export const getCourseLine = async (id: number) => {
  const { data } = await requester().get<CourseLine>(`course-lines/${id}/`);
  return data;
};

export type CreateCourseLine = Omit<
  CourseLine,
  'id' | 'createdAt' | 'updatedAt'
>;

export const createCourseLine = async (body: CreateCourseLine) => {
  const formData = convertToFormData(body, {
    bannerImg: bannerImgConverter,
  });

  const { data } = await requester().post<CourseLine>(
    'course-lines/',
    formData,
    {
      headers,
    },
  );

  return data;
};

export type UpdateCourseLine = Partial<CreateCourseLine>;

export const updateCourseLine = async (id: number, body: UpdateCourseLine) => {
  const formData = convertToFormData(body, {
    bannerImg: bannerImgConverter,
  });

  const { data } = await requester().patch<CourseLine>(
    `course-lines/${id}/`,
    formData,
    { headers },
  );

  return data;
};

export const deleteCourseLine = async (id: number) => {
  await requester().delete(`course-lines/${id}/`);
};
